// datatable related plugins
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  REGISTRY_INVOICE_FIELD,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import React, { useEffect, useState } from "react";
import { customFilter, selectFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import { resetSetBuStoreHeader } from "store/actions";
import {
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_SUCCESS,
} from "store/dashboard/actionTypes";
import {
  downloadReportInvoice,
  getReportInvoiceList,
  resetDownloadReportInvoice,
  resetReportInvoiceList,
  setColumnVisibleReportInvoiceList,
} from "store/summary-invoice-data/actions";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  getReportStatus,
  getTimeContent,
  TYPE_REPORT,
} from "./helper/functionHelper";
const ListData = props => {
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);

  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const toggleViewDetailModal = () => setModalDetail(!modalDetail);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const { type, fileDownload, fileDownloadName } = summaryInvoiceData;
  const { loading, listData, totalCount, columnsVisible, params } =
    summaryInvoiceData.reportInvoiceList;
  const history = useHistory();

  const { t, i18n } = useTranslation(["summaryInvoiceData"]);

  const [commonStatus, setCommonStatus] = useState(getReportStatus(t));

  useEffect(() => {
    setCommonStatus(getReportStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
    }
  }, [type]);

  //   useEffect(() => {
  //     switch (type) {
  //       case RELEASE_INVOICE_CYCLES_SUCCESS:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thành công", {
  //           appearance: "success",
  //           autoDismiss: true,
  //         });
  //         toggleHSMSignModal();
  //         dispatch(getReportInvoiceList(params));
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //       case RELEASE_INVOICE_CYCLES_FAIL:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thất bại", {
  //           appearance: "error",
  //           autoDismiss: true,
  //         });
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //     }
  //   }, [type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, type: typeDashboard } = Dashboard;

  // Action list chang tenantCode
  const [isCheckChangeStore, setIsCheckChangeStore] = useState(false);
  useEffect(() => {
    if (typeDashboard === SET_BU_STORE_HEADER) {
      setIsCheckChangeStore(true);
    }
    if (typeDashboard === SET_BU_STORE_HEADER_SUCCESS && isCheckChangeStore) {
      params.page = 1;
      dispatch(getReportInvoiceList(params, TYPE_REPORT.ERROR));
      dispatch(resetSetBuStoreHeader());
    }
  }, [typeDashboard]);

  useEffect(() => {
    initColumn();
    return () => {
      dispatch(resetReportInvoiceList());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail(row);
      toggleViewDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      text: "Download file",
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        dispatch(
          downloadReportInvoice(
            row.id,
            "BẢNG TỔNG HỢP THÔNG BÁO GỬI CQT " + getTimeContent(row.parameters)
          )
        );
      },
    },
  ];

  const OPTION_HTHUC = [
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD,
      label: t("select.hthuc_add"),
    },
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT,
      label: t("select.hthuc_edit"),
    },
  ];

  const selectFilterHTHUC = {
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD]:
      t("select.hthuc_add"),
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT]:
      t("select.hthuc_edit"),
  };

  const getAuthStatus = (status, id) => {
    let infoError = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
  };

  const listKHMHD = [
    {
      value: 1,
      label: "1 - Hóa đơn GTGT",
    },
    {
      value: 2,
      label: "2 - Hóa đơn bán hàng",
    },
    {
      value: 5,
      label: "5 - Tem vé",
    },
  ];

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    // {
    //   dataField: "type",
    //   text: "Mẫu số hóa đơn",
    //   formatter: (cell, row) => {
    //     // if (
    //     //   cell &&
    //     //   listKHMHD.some(
    //     //     ([key, value]) => value === cell
    //     //   )
    //     // ) {
    //     return `${cell} - ${t(`khmhdon_list.${cell}`)}`;
    //     // }

    //     // return cell || "";
    //   },
    //   filter: customFilter({
    //     type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
    //   }),
    //   filterRenderer: (onFilter, column) => (
    //     <CustomSelectFilter
    //       onFilter={onFilter}
    //       column={column}
    //       paramFilter={params.columnFilter}
    //       dataSelect={listKHMHD}
    //       placeholder={t("placeholder.select")}
    //     />
    //   ),
    // },
    {
      dataField: "parameters",
      text: "Thời gian thống kê",
      hidden: false,
      formatter: (cellContent, row) => {
        return getTimeContent(cellContent);
      },
    },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row.auth_status, row.id),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterAuthStatus,
      }),
    },
    {
      dataField: "bu_code",
      text: "Mã chi nhánh/ đơn vị",
      sort: true,
      formatter: (cellContent, row) => (cellContent ? cellContent : "Tất cả"),
    },
    {
      dataField: "checker_date",
      text: "Ngày tạo",
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getReportInvoiceList(params, TYPE_REPORT.ERROR));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getReportInvoiceList(params, TYPE_REPORT.ERROR));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleReportInvoiceList(field, value));
  };

  const resetDataFunc = () => {
    dispatch(getReportInvoiceList(params, TYPE_REPORT.ERROR));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách Bảng tổng hợp hóa đơn sai sót 04/SS-HĐĐT</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={
              "Danh sách Bảng tổng hợp hóa đơn sai sót 04/SS-HĐĐT" +
              ` (${totalCount})`
            }
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          history.push("/report/create-report-invoice-error");
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Thêm mới
                      </Button>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
